import { useRef, useState } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { PrintTemplateA5Printer } from "./PrintTemplateA5Printer";
import PrintTemplateA5 from "./PrintTemplateA5";
import { PrintTemplateS1Printer } from "./PrintTemplateS1Printer";
import PrintTemplateS1 from "./PrintTemplateS1";
import { PrintTemplateS11Printer } from "./PrintTemplateS11Printer";
import PrintTemplateS11 from "./PrintTemplateS11";
import { PrintTemplateS2Printer } from "./PrintTemplateS2Printer";
import PrintTemplateS2 from "./PrintTemplateS2";
import { PrintTemplateS3Printer } from "./PrintTemplateS3Printer";
import PrintTemplateS3 from "./PrintTemplateS3";
import PrintTemplateA4 from "./PrintTemplateA4";
import { PrintTemplateA4Printer } from "./PrintTemplateA4Printer";

interface Props {
  handlePrint: any;
  toningData: any;
}

const ToningPrinterOptions = (props: Props) => {
  const [printing, setPrinting] = useState({ format: "" });
  const componentRefA4 = useRef() as React.MutableRefObject<any>;
  const componentRefA5 = useRef() as React.MutableRefObject<any>;
  const componentRefS1 = useRef() as React.MutableRefObject<any>;
  const componentRefS11 = useRef() as React.MutableRefObject<any>;
  const componentRefS2 = useRef() as React.MutableRefObject<any>;
  const componentRefS3 = useRef() as React.MutableRefObject<any>;



  const handlePrintA4 = useReactToPrint({
    content: () => componentRefA4.current,
    pageStyle: `
      @page {
        margin: 5mm; /* Reduce margin size */
      }
      body {
        margin: 0; /* Ensure no extra margin */
      }
    `,
  });

  const handlePrintA5 = useReactToPrint({
    content: () => componentRefA5.current,
    pageStyle: `
      @page {
        margin: 5mm; /* Reduce margin size */
        size: A5;
        size: 148mm 210mm;
      }
      body {
        margin: 0; /* Ensure no extra margin */
        size: 148mm 210mm;
      }
    `,
  });

  const handlePrintS11 = useReactToPrint({
    content: () => componentRefS11.current,
    documentTitle: "Dokument",
    pageStyle: `
      @page {
        margin: 0mm; /* Reduce margin size */
        size: 59mm 25mm;
        
      }
      
    `,
  });

  const handlePrintS2 = useReactToPrint({
    content: () => componentRefS2.current,
      documentTitle: "Dokument",
    pageStyle: `
      @page {
        margin: 2mm; /* Reduce margin size */
        size: 59mm 100mm;
        
      }
      
    `,
  });

  const handlePrintS3 = useReactToPrint({
    content: () => componentRefS3.current,
      documentTitle: "Dokument",
    pageStyle: `
      @page {
        margin: 2mm; /* Reduce margin size */
        size: 59mm 100mm;
        
      }
      
    `,
  });




  return (
    <div className="row" style={{ justifyContent: "center" }}>
      <div className="col-12" style={{ textAlign: "center" }}>
        {printing.format == "A4" && <PrintTemplateA4Printer ref={componentRefA4} toningData={props.toningData} />}
        {printing.format == "A5" && <PrintTemplateA5Printer ref={componentRefA5} toningData={props.toningData} />}
        {printing.format == "S1" && <PrintTemplateS1Printer ref={componentRefS1} toningData={props.toningData} />}
               {printing.format == "S11" && <PrintTemplateS11Printer ref={componentRefS11} toningData={props.toningData} />}
        {printing.format == "S2" && <PrintTemplateS2Printer ref={componentRefS2} toningData={props.toningData} />}
       {printing.format == "S3" && <PrintTemplateS3Printer ref={componentRefS3} toningData={props.toningData} />}
        <a
          className="btn btn-sm btn-primary"
          onClick={() => {
            setPrinting({ format: "A4" });

            setTimeout(() => {
              handlePrintA4();
            }, 1);
          }}
          style={{
            backgroundColor: " #55acee;",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
          role="button"
        >
          <i className="fas fa-print me-2"></i>A4
        </a>

        <a
          className="btn btn-sm btn-primary"
          onClick={() => {
            setPrinting({ format: "A5" });

            setTimeout(() => {
              handlePrintA5();
            }, 1);
          }}
          style={{
            backgroundColor: " #55acee;",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
          role="button"
        >
          <i className="fas fa-print me-2"></i>A5
        </a>

   

        <a
          className="btn btn-sm btn-primary"
          onClick={() => {
            setPrinting({ format: "S1" });

            setTimeout(() => {
              //  handlePrintS1();
            }, 1);
          }}
          style={{
            backgroundColor: " #55acee;",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
          role="button"
        >
          <i className="fas fa-print me-2"></i>S1 Hostemix PDF
        </a>

   <a
          className="btn btn-sm btn-primary"
          onClick={() => {
            setPrinting({ format: "S11" });

            setTimeout(() => {
               handlePrintS11();
            }, 1);
          }}
          style={{
            backgroundColor: " #55acee;",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
          role="button"
        >
          <i className="fas fa-print me-2"></i>S1 Hostemix
        </a>


           <a
          className="btn btn-sm btn-primary"
          onClick={() => {
            setPrinting({ format: "S2" });

            setTimeout(() => {
              handlePrintS2();
            }, 1);
          }}
          style={{
            backgroundColor: " #55acee;",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
          role="button"
        >
          <i className="fas fa-print me-2"></i>S2
        </a>

        <a
          className="btn btn-sm btn-primary"
          onClick={() => {
            setPrinting({ format: "S3" });

            setTimeout(() => {
              handlePrintS3();
            }, 1);
          }}
          style={{
            backgroundColor: " #55acee;",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
          role="button"
        >
          <i className="fas fa-print me-2"></i>S3
        </a> 
      </div>
    </div>
  );
};

export default ToningPrinterOptions;
